import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm10 from "../data/form10.data";
import { EmployeeApi } from "../../../../../api/employee/employee.api";
import { useSelector } from "react-redux";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form10: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const { profile } = useSelector((state: any) => state.profile);

  const [inputValueFormLeave10, setInputValueFormLeave10] = useState({
    information: {
      salary_amount: 0,
      spouse: "",
      spouse_last_name: "",
      position_name: "",
      affiliation_name: "",
      department_name: "",
      country: "",
      scheduled_year: 0,
      scheduled_month: 0,
      scheduled_day: 0,
      start_date: "",
      end_date: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave10.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave10]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave10({
        information: data.condition,
      });
    }
  }, []);

  const getEmployeeDetail = async (id: number) => {
    try {
      const res = await EmployeeApi.getOne(id);
      const data = res.data;

      // เก็บแยก 2 field ตอน save (ชื่อ / นามสกุลคู่สมรส) — การแสดงผลรวมกันจัดการที่ฟอร์มผ่าน concatWith
      setInputValueFormLeave10((prev: any) => ({
        information: {
          ...prev.information,
          spouse: data?.data?.parent_info?.spouse_name ?? "",
          spouse_last_name: data?.data?.parent_info?.spouse_last_name ?? "",
        },
      }));
    } catch (error) {
      setInputValueFormLeave10((prev: any) => ({
        information: {
          ...prev.information,
          spouse: "",
          spouse_last_name: "",
        },
      }));
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (profile && profile.id_employee) {
      getEmployeeDetail(profile?.id_employee);
    }
  }, [profile?.id_employee]);

  return (
    <FormComponent
      formGenerate={generateForm10}
      inputValue={inputValueFormLeave10}
      setInputValue={setInputValueFormLeave10}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form10;
